import { render, staticRenderFns } from "./BusinessStructure.vue?vue&type=template&id=36e53ad1&"
import script from "./BusinessStructure.vue?vue&type=script&lang=js&"
export * from "./BusinessStructure.vue?vue&type=script&lang=js&"
import style0 from "./BusinessStructure.vue?vue&type=style&index=0&id=36e53ad1&prod&lang=scss&"
import style1 from "../../../node_modules/v-calendar/lib/v-calendar.min.css?vue&type=style&index=1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports